'use strict';
'use client';
import { j as t } from "../../external/react/jsx-runtime.js";
import { FontAwesomeIcon as p } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { useState as c } from "react";
import i from "../../external/classnames/index.js";
import { faImage as d, faPaperclip as h, faPaperPlane as j } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { useTheme as y } from "../Provider/index.js";
const P = ({
  onSubmit: u,
  onAttachImage: m,
  onAttachFile: g,
  showAttachImage: n = !0,
  showAttachFile: s = !0,
  disabled: r = !1
}) => {
  const { isMosh: f, isMoshy: x } = y(), [l, o] = c("");
  return /* @__PURE__ */ t.jsxs(
    "form",
    {
      className: "flex flex-row gap-4 flex-nowrap py-4 px-4 md:px-8",
      onSubmit: (e) => {
        e.preventDefault(), u(l), o("");
      },
      children: [
        /* @__PURE__ */ t.jsxs("div", { className: "flex flex-row gap-4 w-full relative", children: [
          /* @__PURE__ */ t.jsx(
            "input",
            {
              id: "message-input",
              disabled: r,
              autoFocus: !0,
              type: "text",
              value: l,
              onChange: (e) => o(e.currentTarget.value),
              placeholder: "Type your message...",
              className: i(
                "grow bg-grey-100 rounded-full outline-none py-3 pl-4",
                {
                  "pr-4": !n && !s,
                  "pr-[2.5rem]": n && !s || s && !n,
                  "pr-[4.5rem]": n && s
                }
              )
            }
          ),
          /* @__PURE__ */ t.jsx("label", { hidden: !0, htmlFor: "message-input", children: "Message" }),
          /* @__PURE__ */ t.jsxs("div", { className: "flex flex-row absolute right-2", children: [
            n ? /* @__PURE__ */ t.jsx(
              "label",
              {
                htmlFor: "attach-image",
                className: i(
                  "text-grey-400 shrink py-3 px-2",
                  {
                    "cursor-pointer": !r
                  }
                ),
                children: /* @__PURE__ */ t.jsx(p, { icon: d })
              }
            ) : null,
            /* @__PURE__ */ t.jsx(
              "input",
              {
                id: "attach-image",
                disabled: r,
                type: "file",
                accept: "image/png, image/jpg, image/jpeg",
                hidden: !0,
                onChange: (e) => {
                  var a;
                  (a = e == null ? void 0 : e.target) != null && a.files && m(e.target.files[0]);
                }
              }
            ),
            s ? /* @__PURE__ */ t.jsx(
              "label",
              {
                htmlFor: "attach-file",
                className: i(
                  "text-grey-400 shrink py-3 px-2",
                  {
                    "cursor-pointer": !r
                  }
                ),
                children: /* @__PURE__ */ t.jsx(p, { icon: h })
              }
            ) : null,
            /* @__PURE__ */ t.jsx(
              "input",
              {
                id: "attach-file",
                disabled: r,
                type: "file",
                accept: ".pdf, .txt, .doc, .docx",
                hidden: !0,
                onChange: (e) => {
                  var a;
                  (a = e == null ? void 0 : e.target) != null && a.files && g(e.target.files[0]);
                }
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ t.jsx(
          "button",
          {
            type: "submit",
            "aria-label": "Send",
            disabled: l.length === 0 || r,
            className: i(
              "flex rounded-full items-center justify-center p-4",
              {
                "bg-grey-100": l.length === 0 || r,
                "bg-green-faint-dark": l.length > 0 && f,
                "bg-blue": l.length > 0 && x
              }
            ),
            children: /* @__PURE__ */ t.jsx(
              p,
              {
                icon: j,
                className: i({
                  "text-grey-400": l.length === 0 || r,
                  "text-white": l.length > 0
                })
              }
            )
          }
        )
      ]
    }
  );
};
export {
  P as default
};
